import { AVAILABLE_REGIONS } from '@const/index';
type DeliverySortable = {
  deliveryTypeNameLanguageKey?: string;
  deliveryNameLanguageKey?: string;
  logisticsTime?: number;
  leadTime?: number;
  expectedDeliveryDate?: string;
};
export const isEuroRegion = (region: string): boolean => region === AVAILABLE_REGIONS.euro;

/** Delivery duration ascending — same order as PL (fastest → longest). */
const getDeliverySortTime = (delivery: DeliverySortable): number => {
  if (typeof delivery.logisticsTime === 'number' || typeof delivery.leadTime === 'number') {
    return (delivery.logisticsTime ?? 0) + (delivery.leadTime ?? 0);
  }
  if (delivery.expectedDeliveryDate) {
    const timestamp = new Date(delivery.expectedDeliveryDate).getTime();
    return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp;
  }
  return Number.MAX_SAFE_INTEGER;
};
export const sortEuroDeliveries = <T extends DeliverySortable,>(deliveries: T[], region: string): T[] => {
  if (!isEuroRegion(region) || !deliveries.length) {
    return deliveries;
  }
  return [...deliveries].sort((a, b) => getDeliverySortTime(a) - getDeliverySortTime(b));
};
export const sortEuroDeliveriesResponse = <T extends DeliverySortable,>(response: Record<string, T[]>, region: string): Record<string, T[]> => {
  if (!isEuroRegion(region)) {
    return response;
  }
  const sortedResponse: Record<string, T[]> = {};
  Object.entries(response).forEach(([key, deliveries]) => {
    sortedResponse[key] = Array.isArray(deliveries) ? sortEuroDeliveries(deliveries, region) : deliveries;
  });
  return sortedResponse;
};